import React from 'react'

import { Modal, Form, Col, Button, Row } from '_zari/core'

import { ZariContext } from '_zari/context'

import { DownloadAxiosFile } from 'utils'

import * as FacturacionHistorialService from 'services/facturacionHistorial.service'

import * as FormGroups from './formGroups'

const DescargaMasivaModal = ({ handleClose, show }) => {
  const __zariContext = React.useContext(ZariContext)
  const [fecha, setFecha] = React.useState('')
  const [tipoDocumento, setTipoDocumento] = React.useState('')
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  const clickDescargar = React.useCallback(() => {
    setIsSubmitting(true)
    __zariContext.loader.open('Descargando documentos de forma masiva')

    if (tipoDocumento === '' || fecha === '') {
      __zariContext.snack('error', 'Todos los campos son requeridos')
      setIsSubmitting(false)
      return
    }

    FacturacionHistorialService.descargaMasiva({ fecha, tipoDocumento })
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
        __zariContext.snack('success', 'La descarga se realizo con exito')
        handleClose()
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
        setIsSubmitting(false)
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, tipoDocumento, fecha, handleClose])

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>Descarga Masiva</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Col>
            <Row>
              <Col md={12}>
                <FormGroups.FechaFormGroup value={fecha} onChange={e => setFecha(e.target.value)} isSubmitting={isSubmitting} />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroups.TipoDocumentoFormGroup
                  value={tipoDocumento}
                  onChange={e => setTipoDocumento(e.target.value)}
                  isSubmitting={isSubmitting}
                />
              </Col>
            </Row>
          </Col>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose} disabled={isSubmitting}>
          Cancelar
        </Button>
        <Button color='secondary' onClick={clickDescargar} disabled={isSubmitting}>
          Descargar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DescargaMasivaModal
